import React from 'react';
import { useTranslation } from 'react-i18next';
import { useTheme } from 'styled-components';

import { CheckmarkIcon, CrossmarkIcon } from 'assets/icons';
import { Paragraph } from 'common/components';
import { Flex } from 'components/styled/Flex';
import { TPasswordStrength } from 'modules/account/features/singup/models';

export const PasswordStrength = ({ conditionValues }: { conditionValues: TPasswordStrength[] }) => {
  const { t } = useTranslation();
  const { colors, fontFamily } = useTheme();

  return (
    <>
      {conditionValues?.map((item: TPasswordStrength, index: number) => {
        const { isValid, title } = item;

        return (
          <Flex key={index} alignItems="center" margin="0 0 0 0.5rem">
            {isValid ? (
              <CheckmarkIcon stroke={colors.positive_dark} />
            ) : (
              <CrossmarkIcon stroke={colors.negative_dark} />
            )}

            <Paragraph
              fontFamily={fontFamily.regular}
              fontSize="0.875rem"
              fontWeight="400"
              letterSpacing="0.013rem"
              margin="0 0 0 0.5rem"
            >
              {t(title)}
            </Paragraph>
          </Flex>
        );
      })}
    </>
  );
};
